export const SET_PERSON = 'setPerson'
export const SET_PERSONS = 'setPersons'
export const PERSON_RESET_STATE = 'personResetState' 